import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { UserLight } from '../models/userLight';
import { AuthService } from '../services/auth.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ClientService } from '../services/client.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-users',
  templateUrl: './users.component.html',
  styleUrls: ['./users.component.less']
})
export class UsersComponent implements OnInit {
  usrs : Array<UserLight>;
  selectedUser : UserLight;
  createMode : boolean;
  clientId : number;
  newUser : UserLight = new UserLight();
  constructor(public toast: ToastrService,public location: Router, public activatedRoute: ActivatedRoute,public users: UserService, public auth : AuthService, public clients : ClientService) {
    this.auth.postLoginRedirect = '/users/list/'+ this.clientId;
    this.auth.hasRedirect = true;
    this.auth.roleFetchComplete.subscribe((dta: any)=>{
        console.log('roles fetched');
        // TODO : pass the status code so know if we should actually redirect(401).
        if(dta.status == 401)this.location.navigateByUrl('/auth');
        else if(dta.status == 500) this.toast.error(`error ${dta}`);
    });
   }

  ngOnInit() {
    this.activatedRoute.paramMap.subscribe(
      (params: ParamMap) =>{
        this.clientId = parseInt(params.get('client'),10);
        this.auth.postLoginRedirect = '/users/list/'+ this.clientId;
        if (!localStorage.getItem('STP-JWT')) {
          this.location.navigateByUrl('/auth')
        } else {
          this.auth.GetUsersRoles();
          // Get all the users for this caller. if none come back then 
          this.clients.FetchClientUsers(this.clientId).subscribe(
            (rsp: any) => {
              // console.log('fetch users returned', rsp);
              this.usrs = rsp;
            },
            (err: any) => {
              console.log('fetch users error', err);
              // TODO : toast it
            })
        }
      });
    

  }

  update(ev : any){
    console.log(ev);
    if(this.createMode){
      this.newUser[ev.name] = ev.value;
    }else{
      this.selectedUser[ev.name] = ev.value;
    }
  }

  createUser(){
    this.location.navigateByUrl('user/create/'+ this.clientId)
  }
  resetPass(usr: UserLight){
    this.auth.ChangePassword(usr).subscribe((rsp: any) => {
      console.log('PWReset call returned', rsp);
      this.toast.success('user saved successfully', '', {timeOut:5000});
    },
      (err: any) => {
        this.toast.error('error saving user');
        if(err.status == 401){
          this.location.navigateByUrl('auth');
        }
        // this.LoginError = true;
        // console.log('PWReset call returned', err);
        // this.ValidationMessage = err.error;
      })
  }

  selectUser(usr: UserLight){
    if(usr.selected){
      this.selectedUser = undefined;
    }else{
      this.selectedUser = usr;
    }
    usr.selected = !usr.selected;
  }
}
